import { z } from "zod";

export const PLATFORM_FEATURE_KEYS = {
  workerDocumentsEnabled: "worker_documents_enabled",
} as const;

export type PlatformFeatureKey =
  (typeof PLATFORM_FEATURE_KEYS)[keyof typeof PLATFORM_FEATURE_KEYS];

export const PLATFORM_ROLES = {
  PLATFORM_ADMIN: "PLATFORM_ADMIN",
} as const;

export type PlatformRole = (typeof PLATFORM_ROLES)[keyof typeof PLATFORM_ROLES];

export const ENABLE_WORKER_DOCUMENTS_CONFIRMATION = "ENABLE WORKER DOCUMENTS";

export const platformFeatureFlagValueSchema = z.object({
  enabled: z.boolean(),
});

export const platformFeaturesResponseSchema = z.object({
  workerDocumentsEnabled: z.boolean(),
});

export const updateWorkerDocumentsFeatureSchema = z
  .object({
    enabled: z.boolean(),
    reason: z.string().trim().max(2000).optional().nullable(),
    confirmationPhrase: z.string().trim().optional(),
  })
  .superRefine((value, ctx) => {
    if (value.enabled && value.confirmationPhrase !== ENABLE_WORKER_DOCUMENTS_CONFIRMATION) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["confirmationPhrase"],
        message: `Type ${ENABLE_WORKER_DOCUMENTS_CONFIRMATION} to confirm.`,
      });
    }
  });

export type PlatformFeaturesResponse = z.infer<typeof platformFeaturesResponseSchema>;
export type UpdateWorkerDocumentsFeatureInput = z.infer<
  typeof updateWorkerDocumentsFeatureSchema
>;
